import React, { FC, memo } from 'react'
import FlyOutTabs from 'components/Owner/Tools/ToolFlyout/FlyOutTabs'
import { Popover } from 'react-tiny-popover'
import { BasicInfo } from 'types'

export interface IToolFlyoutPopupProps {
  setOpen: (param: boolean) => void
  isOpen: boolean
  handleClick: (param: string) => void
  toolFlyoutOptions: BasicInfo[]
}

const ToolFlyoutPopup: FC<IToolFlyoutPopupProps> = ({
  setOpen,
  isOpen,
  handleClick,
  toolFlyoutOptions,
}) => {
  return (
    <Popover
      isOpen={isOpen}
      align="center"
      positions={['bottom']}
      onClickOutside={() => setOpen(false)}
      content={
        <div className="rounded-lg bg-white rounded-[10px] p-2 shadow-md relative">
          {toolFlyoutOptions.map((option, index) => (
            <FlyOutTabs option={option} handleClick={handleClick} key={index} />
          ))}
        </div>
      }
    >
      <div className="absolute mt-3 ml-8"></div>
    </Popover>
  )
}

export default memo(ToolFlyoutPopup)
